export const API_HOST = process.env.REACT_APP_API_HOST;

export const REFERRER_URL = `${API_HOST}/email/general/pa/`;
export const CONTACT_US_URL = `${API_HOST}/email/general/co/`;
export const SOFR_RATE_URL = `${API_HOST}/trade/interest_rate/sofr/`;
export const HIBOR_RATE_URL = `${API_HOST}/trade/interest_rate/hibor/`;